import React, { useEffect } from 'react';
import { TASK, ENV, fullSrc } from '../../lib/gallery';

const details = (r) => [["Task", TASK(r)], ["Environment", ENV(r)],
  ["Lighting", r.lighting], ["Action", r.action], ["Activities in clip", r.activities], ["Workflow step", r.workflow_step], ["Objects", r.objects], ["Tools", r.tools],
  ["Recorded", r.recording_date], ["Cap", r.cap], ["Upload batch", r.source_batch], ["Session", r.session_ref],
  ["Faces blurred", r.faces_blurred], ["Score", r.score + "/10"]].filter(([, v]) => v);

const NavBtn = ({ onClick, children, id }) => (
  <button type="button" onClick={onClick} data-testid={`lightbox-${id}`}
    className="flex-1 rounded-lg border border-white/10 bg-white/[0.04] py-2 text-sm hover:border-[#FF7A00]/50 hover:text-[#FF7A00] transition-colors">
    {children}
  </button>
);

export const GalleryLightbox = ({ r, onPrev, onNext, onClose }) => {
  useEffect(() => {
    const h = (e) => {
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', h);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', h); document.body.style.overflow = ''; };
  }, [onPrev, onNext, onClose]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-3" data-testid="gallery-lightbox">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="lightbox-backdrop" />
      <div className="relative z-10 w-full max-w-[min(1200px,96vw)] max-h-[94vh] bg-[#141414] border border-white/10 rounded-2xl overflow-hidden grid md:grid-cols-[minmax(0,2fr)_minmax(240px,1fr)]">
        <img src={fullSrc(r)} alt={r.caption} className="w-full h-full max-h-[50vh] md:max-h-[94vh] object-contain bg-black" data-testid="lightbox-image" />
        <aside className="px-5 pt-5 overflow-y-auto max-h-[44vh] md:max-h-[94vh]">
          <h4 className="text-base font-bold mb-1" data-testid="lightbox-title">{r.category} · {TASK(r)}</h4>
          <p className="text-sm text-white/45 mb-4" data-testid="lightbox-caption">{r.caption}</p>
          <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-[13px]">
            {details(r).map(([k, v]) => (
              <React.Fragment key={k}><dt className="text-white/40">{k}</dt><dd className="m-0 break-words text-white/85">{v}</dd></React.Fragment>
            ))}
          </dl>
          <nav className="sticky bottom-0 -mx-5 px-5 py-3 bg-[#141414] border-t border-white/10 flex gap-2 mt-5">
            <NavBtn onClick={onPrev} id="prev">← Prev</NavBtn>
            <NavBtn onClick={onNext} id="next">Next →</NavBtn>
            <NavBtn onClick={onClose} id="close">Close</NavBtn>
          </nav>
        </aside>
      </div>
    </div>
  );
};
